import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import user from '@/store/modules/userModule';
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
  },
  strict: process.env.DEV,
})
